import React, { useEffect, useState } from 'react'
import { formattedGlobalDate } from '../../utils/formattedDates';
import { MDBCol, MDBRow } from 'mdb-react-ui-kit';
import SwitchButton from '../../componentes/SwitchButton';
import axios from '../../utils/axiosConfig';
import Swal from 'sweetalert2';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';
import '../../Pages/Css/solicitudes.css';
import '../../Pages/Css/trackingMonitoreo.css';
import {
    preferredLocalToUTCDateTime,
    utcToPreferredLocalDateTime,
} from '../../utils/timezoneDateConversion';

const FormReporteServcioModalTracking = ({
    contrato,
    lastReport,
    bitInsert = false,
    bitEdit = false,
}) => {
    const [fHora, setFHora] = useState('');
    const [fHoraFormatted, setFHoraFormated] = useState(null);
    const [notas, setNotas] = useState(null);
    const [ubicacion, setUbicacion] = useState(null);
    const [listReportes, setListReportes] = useState([]);
    const [listTiposEstados, setListTiposEstados] = useState([]);
    const [tipoReportes, setTipoReportes] = useState([]);
    const [idReport, setIdReport] = useState(null);
    const [selectedTipyStatus, setSelectedTipyStatus] = useState(null);
    const [selectedTipyAction, setSelectedTipyAction] = useState(null);
    const [asegurado, setAsegurado] = useState("");
    const [individual, setIndividual] = useState(false);
    const [openActionMenuId, setOpenActionMenuId] = useState(null);
    const userSolicitud = localStorage.getItem('username');

    useEffect(() => {
        const closeActionMenu = (event) => {
            if (!event.target.closest('.tracking-action-menu')) setOpenActionMenuId(null);
        };
        document.addEventListener('mousedown', closeActionMenu);
        return () => document.removeEventListener('mousedown', closeActionMenu);
    }, []);

    const idSolicitud = contrato;
    //METHOD SORT
    const [sortBy, setSortBy] = useState(null);
    const [sortDirection, setSortDirection] = useState('asc');

    const handleCheckboxChangeIndividual = (newValue) => {
        setIndividual(newValue);
        console.log(newValue);
    };

    const handleDateTimeChangeHoraCita = (e) => {
        const value = e.target.value;
        setFHora(value);

        const utcValue = preferredLocalToUTCDateTime(value, {
            separator: ' ',
            withSeconds: true,
        });
        setFHoraFormated(utcValue || null);
    };

    const formattedSetTime = (time) => {
        // Divide la cadena en fecha y hora
        const localValue = utcToPreferredLocalDateTime(time, {
            separator: 'T',
            withSeconds: false,
        });
        setFHora(localValue || '');
        const utcValue = preferredLocalToUTCDateTime(localValue, {
            separator: ' ',
            withSeconds: true,
        });
        setFHoraFormated(utcValue || null);
    };

    const handleSelectChangeTipoAccion = (event) => {
        const selectState = parseInt(event.target.value);
        setSelectedTipyAction(selectState);
        // console.log("Tipo accion selescted: ", selectState);
    }
    const handleSelectChangeTipoStatus = (event) => {
        const selectState = parseInt(event.target.value);
        setSelectedTipyStatus(selectState);
        // console.log("Tipo estado selescted: ", selectState);
    }

    //LISTAR SOLISICITUDES REPORTES
    const listarReporteServicios = () => {
        let dataContrato = {
            contrato: idSolicitud
        }
        axios
            .post(process.env.REACT_APP_SERVER + "/contratos/getreportestrafico", JSON.stringify(dataContrato), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success == false) {
                    window.location = "/";
                } else {
                    // console.log("Informacion REPORTE SEGU8IMINETO SERVICIO: ", res.data.data);
                    setListReportes(res.data.data);
                }
            }).catch((err) => console.error(err));
    }

    //LISTAR EESTADOS
    const listTipoAccionesReportes = () => {

        axios
            .get(process.env.REACT_APP_SERVER + "/contratos/gettipoacciones", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success == false) {
                    window.location = "/";
                } else {
                    // console.log("Informacion REPORTE SEGU8IMINETO accion realizada: ", res.data.data);
                    setTipoReportes(res.data.data);
                }
            }).catch((err) => console.error(err));
    }
    const listTipoEstadoReporte = () => {

        axios
            .get(process.env.REACT_APP_SERVER + "/contratos/gettiporeportes", {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success == false) {
                    window.location = "/";
                } else {
                    // console.log("Informacion REPORTE SEGU8IMINETO estados servicio: ", res.data.data);
                    setListTiposEstados(res.data.data);
                }
            }).catch((err) => console.error(err));
    }

    //CARGAR INFO
    const loadFillData = (array) => {
        // console.log("este es el array de la funcion loadFillData", array);
        return array.map((data) => {
            // console.log("Data XTIME: ", data.XTime);
            // Función para formatear la fecha y hora
            const formatDate = (dateTimeString) => {
                // Parsea el string ISO 8601 a objeto Date
                const parsedDate = parseISO(dateTimeString);

                // Formatea la fecha y hora según el formato deseado
                const formattedDate = format(parsedDate, "d MMMM yyyy h:mma", { locale: es });

                return formattedDate;
            };

            const formattedSetTime = (time) => {
                // Divide la cadena en fecha y hora
                const [date, timePart] = time.split('T');

                // Asegúrate de que la parte de la hora no contenga la parte '.000Z'
                const cleanTimePart = timePart.split('.')[0];

                // Combina la fecha y la hora formateada
                const formattedDateTime = `${date} ${cleanTimePart}`;

                // console.log("Datos fecha formateado para actualizar ***", formattedDateTime);

                // Aquí puedes actualizar tu estado o realizar alguna acción con formattedDateTime
                return formattedDateTime;
            };

            const formateo = formattedGlobalDate(data.XTime);


            // const formatedTimeZone = formattedSetTime(data.XTime);

            // Ejemplo de uso con la cadena formateada previamente
            // const formattedDate = formatDate(formatedTimeZone); // Usar aquí tu cadena formateada anteriormente

            return (
                <React.Fragment >
                    {/* <tr onClick={() => this.toggleRow(data.ContractID)}> */}

                    <tr>

                        <td style={{ color: "#000", height: '10px' }}>{formateo}</td>


                        <td style={{ color: "#000" }}>{data.TipoAccion}</td>


                        <td style={{ color: "#000" }}>{data.TipoReporte}</td>


                        <td style={{ color: "#000" }}>{data.Ubicacion}</td>


                        <td style={{ color: "#000" }}>{data.Nota}</td>


                        <td style={{ color: "#000" }}>{data.XUser}</td>


                        <td className="tracking-action-cell">
                            <div className="tracking-action-menu">
                                <button
                                    type="button"
                                    className="tracking-action-trigger"
                                    aria-label="Abrir acciones"
                                    aria-expanded={openActionMenuId === data.IdReport}
                                    onClick={() => setOpenActionMenuId((current) => current === data.IdReport ? null : data.IdReport)}
                                >
                                    <i className="bx bx-dots-vertical-rounded" />
                                </button>
                                {openActionMenuId === data.IdReport && (
                                    <div className="tracking-action-dropdown" role="menu">
                                        <button type="button" onClick={() => { setOpenActionMenuId(null); loadDataUpdate(data.IdReport); }}>
                                            <i className="bx bxs-pencil" /> Editar
                                        </button>
                                        <button type="button" onClick={() => { setOpenActionMenuId(null); deleteReporteSeguimiento(data.IdReport); }}>
                                            <i className="bx bx-trash" /> Eliminar
                                        </button>
                                    </div>
                                )}
                            </div>
                        </td>


                    </tr>

                </React.Fragment >
            )
        })
    }

    const handleChangeAsegurado = () => {
        let dataReporte = {
            FKICTipoReporte: selectedTipyStatus
        }
        axios
            .post(process.env.REACT_APP_SERVER + "/contratos/getaseguradotiporeporte", JSON.stringify(dataReporte), {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                },
                withCredentials: true,
            })
            .then((res) => {
                if (res.data.success == false) {
                    window.location = "/";
                } else {
                    // console.log("Informacion REPORTE SEGU8IMINETO SERVICIO asegurado: ", res.data.data);
                    setAsegurado(res.data.data[0].Asegurar);
                }
            }).catch((err) => console.error(err));
    }

    //CARGAR INFO PARA ACTUALIZAR
    const loadDataUpdate = (idReport) => {
        // console.log("ID Reporte: ", idReport);
        const filteredByIdReport = listReportes.filter((report) => report.IdReport === idReport);
        // console.log(filteredByIdReport);
        const filteredByIdReportState = listTiposEstados.filter((reportstate) => reportstate.TipoReporte === filteredByIdReport[0].TipoReporte);
        const filteredByIdReportAction = tipoReportes.filter((actiontstate) => actiontstate.TipoAccion === filteredByIdReport[0].TipoAccion);
        // console.log("este es el array de la funcion loadDataUpdate cambio de estado : ", filteredByIdReportState);
        formattedSetTime(filteredByIdReport[0].XTime);
        setNotas(filteredByIdReport[0].Nota);
        setSelectedTipyStatus(filteredByIdReportState[0].IdTipoReporte);
        setSelectedTipyAction(filteredByIdReportAction[0].IdTipoAccion);
        setUbicacion(filteredByIdReport[0].Ubicacion);
        setIdReport(filteredByIdReport[0].IdReport);
        setIndividual();
    }

    const insertReporteSeguimiento = () => {
        const xTimeUtc = preferredLocalToUTCDateTime(fHora, {
            separator: ' ',
            withSeconds: true,
        }) || fHoraFormatted;

        let dataReport = {
            FKICTipoReporte: selectedTipyStatus,
            FKLokTipoAccion: selectedTipyAction,
            Nota: notas,
            Ubicacion: ubicacion,
            XTime: xTimeUtc,
            Individual: individual,
            FKLokContractID: idSolicitud
        }
        // console.log("Data sreporte solcicitud antes de subirlo : ", dataReport);
        if (!fHora || !notas || !ubicacion || !selectedTipyStatus || !selectedTipyAction || selectedTipyAction === tipoReportes[0].IdTipoAccion || selectedTipyStatus === listTiposEstados[0].IdTipoReporte) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Debe llenar los campos obligatorios",
                didOpen: () => {
                    const confirmButton = Swal.getConfirmButton();
                    confirmButton.style.backgroundColor = '#ff0000';
                    confirmButton.style.color = '#ffffff';
                    confirmButton.style.border = 'none';
                    confirmButton.style.padding = '10px 20px';
                    confirmButton.style.fontSize = '16px';
                    confirmButton.style.borderRadius = '5px';
                    confirmButton.style.cursor = 'pointer';
                }
            });
        } else {
            axios
                .post(process.env.REACT_APP_SERVER + "/contratos/insertreportetrafico", JSON.stringify(dataReport), {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                })
                .then((res) => {
                    if (res.data.success == false) {
                        window.location = "/";
                    } else {
                        // console.log("Informacion REPORTE SEGU8IMINETO INSERTARRR *****: ", res.data.data);
                        listarReporteServicios();
                        clearFields();
                    }
                }).catch((err) => console.error(err));
        }
    }

    //ACTUALIZAR REPORTE DE SEGUIMIENTO
    const updateReporteSeguimiento = () => {
        const xTimeUtc = preferredLocalToUTCDateTime(fHora, {
            separator: ' ',
            withSeconds: true,
        }) || fHoraFormatted;

        let dataReportUPT = {
            FKICTipoReporte: selectedTipyStatus,
            FKLokTipoAccion: selectedTipyAction,
            Nota: notas,
            Ubicacion: ubicacion,
            XTime: xTimeUtc,
            IdReport: idReport,
        }
        if (!fHora || !notas || !ubicacion || !selectedTipyStatus || !selectedTipyAction || selectedTipyAction === tipoReportes[0].IdTipoAccion || selectedTipyStatus === listTiposEstados[0].IdTipoReporte) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Debe llenar todos los campos.",
                didOpen: () => {
                    const confirmButton = Swal.getConfirmButton();
                    confirmButton.style.backgroundColor = '#ff0000';
                    confirmButton.style.color = '#ffffff';
                    confirmButton.style.border = 'none';
                    confirmButton.style.padding = '10px 20px';
                    confirmButton.style.fontSize = '16px';
                    confirmButton.style.borderRadius = '5px';
                    confirmButton.style.cursor = 'pointer';
                }
            });
        } else {
            axios
                .post(process.env.REACT_APP_SERVER + "/contratos/updatereportetrafico", JSON.stringify(dataReportUPT), {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                })
                .then((res) => {
                    if (res.data.success == false) {
                        window.location = "/";
                    } else {
                        // console.log("Informacion REPORTE SEGU8IMINETO ACTUALIZAR *****: ", res.data.data);
                        listarReporteServicios();
                        clearFields();
                    }
                }).catch((err) => console.error(err));
        }
    }

    //ELIMINAR REPORTE DE SEGUIMIENTO
    const deleteReporteSeguimiento = (IdReport) => {
        // console.log("Id reporte: ", IdReport);
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'custom-confirm-button', // or 'btn btn-info' if you use Bootstrap
                cancelButton: 'custom-cancel-button' // or 'btn btn-danger' if you use Bootstrap
            },
            buttonsStyling: false
        });
        swalWithBootstrapButtons.fire({
            title: "Está seguro?",
            text: "Esto no es reversible!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Si, anular",
            cancelButtonText: "No, cancelar!",
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                let dataReporteAnular = {
                    IdReport: IdReport
                }
                axios
                    .post(process.env.REACT_APP_SERVER + "/contratos/deletereportetrafico", JSON.stringify(dataReporteAnular), {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                        },
                        withCredentials: true,
                    })
                    .then((res) => {
                        if (res.data.success == false) {
                            window.location = "/";
                        } else {
                            listarReporteServicios();
                            swalWithBootstrapButtons.fire({
                                title: "Eliminado!",
                                text: "Su reporte de seguimiento ha sido anulada con éxito.",
                                icon: "success"
                            });

                        }
                    }).catch((err) => console.error(err));


            } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
            ) {
                console.error("no se anuilo la solicitud");
            }
        });


    }



    //LIMPIAR CAMPOS
    const clearFields = () => {
        cargarFechaHoraActual();
        setNotas("");
        setIndividual(false);
        setSelectedTipyAction(tipoReportes[0].IdTipoAccion);
        setSelectedTipyStatus(listTiposEstados[0].IdTipoReporte);
        setIdReport(null);
        setAsegurado("");
        setUbicacion("");
    }

    //CARGAR FECHA HORA ACTUAL APENAS SE CARGA EL COMPONENTE
    const cargarFechaHoraActual = () => {
        const localNow = utcToPreferredLocalDateTime(new Date().toISOString(), {
            separator: 'T',
            withSeconds: false,
        });
        const utcNow = preferredLocalToUTCDateTime(localNow, {
            separator: ' ',
            withSeconds: true,
        });
        setFHora(localNow || '');
        setFHoraFormated(utcNow || null);
    };

    const renderSortIcon = (column) => {

        if (sortBy === column) {
            if (sortDirection === "asc") {
                return <span>&uarr;</span>; // Icono de flecha hacia arriba
            } else {
                return <span>&darr;</span>; // Icono de flecha hacia abajo
            }
        }

        return null; // No mostrar ningún ícono si no está ordenado por esta columna
    }

    useEffect(() => {
        // console.log("Datos de la solicitud: ", lastReport);
        if (lastReport) {
            const geocercaReport = lastReport?.NombreGeocerca ? lastReport?.NombreGeocerca + " " + lastReport?.Ciudad : lastReport?.Ciudad;
            setUbicacion(geocercaReport);
        }
    }, [lastReport]);

    useEffect(() => {
        listarReporteServicios();
        listTipoAccionesReportes();
        listTipoEstadoReporte();
        cargarFechaHoraActual();
    }, []);

    useEffect(() => {
        if (selectedTipyStatus) {
            handleChangeAsegurado();
        }
    }, [selectedTipyStatus]);
    return (
        <div style={{ height: '75vh', marginTop: '15px' }} className='containerMonitoreoTrafico tracking-monitoreo-form'>
            <MDBRow style={{ display: 'flex', alignItems: 'start', justifyContent: 'start', flexDirection: 'column' }}>
                {/* Número de solicitud */}
                <MDBCol md={8} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className="InputTooltipWrapper reporteSeolicitud">
                            <label className="LabelTracking" htmlFor="solicitud">Contrato</label>
                            {/* <TooltipComponent message={'Acá iría el número que identifica la solicitud en curso '} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={8} className='reporteSeolicitudInputt'>
                        <input className="Input" id="name" defaultValue={idSolicitud} disabled />
                    </MDBCol>
                </MDBCol>

                {/* Fecha y hora */}
                <MDBCol md={8} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className='InputTooltipWrapper reporteSeolicitud'>
                            <label className="LabelTracking" htmlFor="fechaHoraCita">Fecha/Hora</label>
                            {/* <TooltipComponent message={'Escoge una fecha y hora para tu solicitud'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={8} className='reporteSeolicitudInputt'>
                        <input className="Input" id="fechaHoraCita" type='datetime-local' value={fHora}
                            onChange={handleDateTimeChangeHoraCita} style={{ textAlign: 'left !important', paddingLeft: '0.5rem' }} />
                    </MDBCol>
                </MDBCol>

                {/* Ubicacion */}
                <MDBCol md={8} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className='InputTooltipWrapper reporteSeolicitud'>
                            <label className="LabelTracking" htmlFor="fechaHoraCita">Ubicacion</label>
                            <span style={{ color: 'red', fontSize: 15 }}>*</span>
                            {/* <TooltipComponent message={'Escoge una fecha y hora para tu solicitud'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={8} className='reporteSeolicitudInputt'>
                        <input className="Input" id="fechaHoraCita" type='text' placeholder='Ubicación del vehículo' value={ubicacion} onChange={(e) => setUbicacion(e.target.value)} />
                    </MDBCol>
                </MDBCol>

                {/* Accion Realizada */}
                <MDBCol md={8} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className="InputTooltipWrapper reporteSeolicitud">
                            <label className="LabelTracking" htmlFor="tipoContrato">Acción Realizada</label>
                            <span style={{ color: 'red', fontSize: 15 }}>*</span>
                            {/* <span style={{ color: 'red', fontSize: 15 }}>*</span> */}
                            {/* <TooltipComponent message={'Selecciona el estado de la solicitud'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={12} className='reporteSeolicitudInputt'>
                        <select className="InputSelectReportSeguimihnetoSol" onChange={handleSelectChangeTipoAccion} value={selectedTipyAction}>
                            {tipoReportes.map((tipo) => (
                                <option key={tipo.IdTipoAccion} value={tipo.IdTipoAccion}>
                                    {tipo.TipoAccion}
                                </option>
                            ))}
                        </select>
                    </MDBCol>
                </MDBCol>

                {/* Estado de solicitud */}
                <MDBCol md={8} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className="InputTooltipWrapper reporteSeolicitud">
                            <label className="LabelTracking" htmlFor="tipoContrato">Estado de servicio</label>
                            <span style={{ color: 'red', fontSize: 15 }}>*</span>
                            {/* <span style={{ color: 'red', fontSize: 15 }}>*</span> */}
                            {/* <TooltipComponent message={'Selecciona el estado de la solicitud'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={12} className='reporteSeolicitudInputt'>
                        <select className="InputSelectReportSeguimihnetoSol" onChange={handleSelectChangeTipoStatus} value={selectedTipyStatus}>
                            {listTiposEstados.map((state) => (
                                <option key={state.IdTipoReporte} value={state.IdTipoReporte}>
                                    {state.TipoReporte}
                                </option>
                            ))}
                        </select>
                    </MDBCol>
                </MDBCol>


                {/* Notas */}
                <MDBCol md={8} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className='contToltip reporteSeolicitud'>
                            <label className="LabelTracking" htmlFor="observacionesServicio">Notas</label>
                            <span style={{ color: 'red', fontSize: 15 }}>*</span>
                            {/* <TooltipComponent message={'Cliente para consultas'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={8} >
                        <textarea className="TextAreaReportSe2" value={notas} onChange={(e) => setNotas(e.target.value)} />
                    </MDBCol>
                </MDBCol>
                <br />

                {/* SwitchButtons */}
                <MDBCol md={6} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className='contToltip reporteSeolicitud'>
                            <label className="LabelTracking" htmlFor="observacionesServicio">Asegurado</label>
                            {/* <TooltipComponent message={'Cliente para consultas'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={12} className='reporteSeolicitudInputt'>
                        {!asegurado ? ' desactivado' : ' activado'}

                    </MDBCol>
                </MDBCol>
                <MDBCol md={6} style={{ display: 'flex', flexDirection: 'row' }} className='columnsStyles'>
                    <MDBCol md={5}>
                        <div className='contToltip reporteSeolicitud'>
                            <label className="LabelTracking" htmlFor="observacionesServicio">Individual</label>
                            {/* <TooltipComponent message={'Cliente para consultas'} /> */}
                        </div>
                    </MDBCol>
                    <MDBCol md={12} className='reporteSeolicitudInputt'>
                        <SwitchButton checked={individual} onChange={handleCheckboxChangeIndividual} type={'\u00A0'} />
                    </MDBCol>
                    <div className="ButtonWrapper" style={{ display: 'flex', justifyContent: 'flex-start', transform: "translate(-70px,-25px)" }}>


                        {idReport ? (
                            <button
                                className="Button blue"
                                disabled={!bitEdit}
                                onClick={(e) => { e.preventDefault(); updateReporteSeguimiento(); }}
                            >Actualizar</button>

                        ) : (
                            <button
                                className="Button blue"
                                disabled={!bitInsert}
                                onClick={(e) => { e.preventDefault(); insertReporteSeguimiento(); }}
                            // data-bs-dismiss='modal'
                            >Grabar</button>

                        )}




                    </div>
                </MDBCol>
            </MDBRow >



            <MDBRow>
                <MDBCol md={12}>
                    <div className="card ContainerTableReportesSolicitudes tracking-real-time-table-card" >
                        <div
                            className="tracking-real-time-table-scroll"
                            style={{
                                height: `calc(75vh - 300px)`,
                                overflowY: "auto",
                                overflowX: "hidden",
                                display: "block",

                                // flexDirection: "column",
                            }}
                        >
                            <table className="table table-hover tracking-real-time-table" id="tabla" style={{ width: "100%", maxWidth: "100%", tableLayout: "fixed" }}>
                                <colgroup>
                                    <col style={{ width: '13%' }} />
                                    <col style={{ width: '16%' }} />
                                    <col style={{ width: '14%' }} />
                                    <col style={{ width: '15%' }} />
                                    <col style={{ width: '20%' }} />
                                    <col style={{ width: '14%' }} />
                                    <col style={{ width: '8%' }} />
                                </colgroup>
                                <thead className="FondoHeaderTabla3">
                                    <tr >

                                        <th
                                            className="tracking-date-header"
                                            style={{ color: "#ffffff", fontSize: '10px' }}
                                        // onClick={() => sortData("IDSolicitudes")}
                                        >
                                            Fecha/Hora {renderSortIcon("IDSolicitudes")}
                                        </th>

                                        <th
                                            style={{ color: "#ffffff", textAlign: 'center', fontSize: '10px' }}
                                        // onClick={() => sortData("NombreEmpresa")}
                                        >
                                            Acción{" "}
                                            {renderSortIcon("NombreEmpresa")}
                                        </th>
                                        <th
                                            style={{ color: "#ffffff", textAlign: 'center', fontSize: '10px' }}
                                        // onClick={() => sortData("NombreEmpresa")}
                                        >
                                            Estado{" "}
                                            {renderSortIcon("NombreEmpresa")}
                                        </th>
                                        <th
                                            style={{ color: "#ffffff", textAlign: 'center', fontSize: '10px' }}
                                        // onClick={() => sortData("NombreEmpresa")}
                                        >
                                            Ubicación{" "}
                                            {renderSortIcon("NombreEmpresa")}
                                        </th>

                                        <th
                                            className="tracking-observations-header"
                                            style={{ color: "#ffffff", textAlign: 'center', fontSize: '10px' }}
                                        // onClick={() => sortData("Ruta")}
                                        >
                                            Observaciones {renderSortIcon("Ruta")}
                                        </th>

                                        <th
                                            style={{ color: "#ffffff", textAlign: 'center', fontSize: '10px' }}
                                        // onClick={() => sortData("PlacaTruck")}
                                        >
                                            Usuario {renderSortIcon("PlacaTruck")}
                                        </th>
                                        <th className="tracking-actions-header" style={{ color: "#ffffff", fontSize: '10px' }} />


                                    </tr>
                                </thead>
                                <tbody className="table-border-bottom-0" id="tabladata">
                                    {loadFillData(listReportes)}
                                    {/* el body */}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </MDBCol>
            </MDBRow>
        </div>
    )
}

export default FormReporteServcioModalTracking
